import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Divider from '@mui/material/Divider';

import FooterComponent from './components/common/footerComponent';
import HeaderComponent from './components/common/header';
import LoginButton from './components/common/loginButton';
import { useAuth } from './components/authentication';
import { Navigate } from 'react-router-dom';

// Styled component for the container
const StyledBox = styled(Box)({
  display: 'flex',
  alignItems: 'center', // aligns items horizontally center
  justifyContent: 'center',
  minHeight: '100vh',
  gap: '16px' // space between elements
});

function App() {
  const { isAuthenticated } = useAuth();
  if (isAuthenticated) {
    return (
      <Navigate to="/manage" />
    );
  }
  else {
    return (
      <styledBox>
        <HeaderComponent />
        <StyledBox>
          <Typography variant="h5" component="h5" sx={{
            cursor: 'default'
          }}>
            DDNS Manager
          </Typography>
          <Divider orientation="vertical" flexItem>
          </Divider>
          <LoginButton />
          <FooterComponent />
        </StyledBox>
      </styledBox>
    );
  }
}

export default App;
